import keyMirror from 'key-mirror';

const ChatbotOrigins = keyMirror({
  OWN: null,
  CHATBOT_COM: null,
  DIALOGFLOW: null,
});

const DisabledChatbotStory = {
  KEY: 'DISABLED',
  NAME: 'Disable chatbot',
  ORIGIN: ChatbotOrigins.OWN,
};

const MiscChatbotStory = {
  KEY: 'MISC',
  NAME: '',
  ORIGIN: ChatbotOrigins.OWN,
};

export { ChatbotOrigins, MiscChatbotStory, DisabledChatbotStory };
